import { SkillLink } from '../skill/SkillLink';
import { Heading3, Heading4 } from '../ui/Heading';


type Buff = Record<string, {
  minLevel: number;
  maxLevel: number;
  skill: {
    id: number;
    skillName: string;
    cardName: string;
    icon: string;
    name: string;
    level: number | null;
  };
}[]>;

type NpcBuff = {
  group: "fighter" | "mage";
  minLevel: number;
  maxLevel: number;
  skill: {
    id: number;
    skillName: string;
    cardName: string;
    icon: string;
    name: string;
    level: number | null;
  };
};

export function BuffList(props: { buffList: NpcBuff[]; }) {
  const list = props.buffList.reduce<Buff>((_group, { group, ...rest }) => {
    _group[group] = _group[group] ?? [];
    _group[group].push(rest);
    return _group;
  }, {});

  // for (const key of Object.keys(list)) {
  //   console.log(key, list[key]);
  // }

  return <div>
    <Heading3>Newbie buffs</Heading3>
    <div className='columns'>{Object.entries(list).map(
      ([key, value]) => <div className={key === "fighter" ? 'column' : 'column is-half'}>
        <Heading4>{key == "fighter" ? "For Fighters" : "For Mages"}</Heading4>
        <div style={{ display: "table", width: "100%" }}>
          <div style={{ display: "table-row", textTransform: "uppercase", fontSize: 12 }}>
            <div style={{ display: "table-cell" }}>Buff name</div>
            <div style={{ display: "table-cell" }}>Req. Level</div>
          </div>
          {value.map(d =>
            <div style={{ display: "table-row", paddingBottom: 5 }}>
              <div style={{ display: "table-cell" }}><SkillLink data={d.skill} /></div>
              <div style={{ display: "table-cell" }}>({d.minLevel} - {d.maxLevel})</div>
            </div>
          )}
        </div>
      </div>
    )}</div>
  </div>;
}